import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import React from 'react'
import { DensityStyleTypes } from 'types'
import { GridCommentCell } from '../shared'

interface RenderGridCommentsProps {
  params: GridRenderCellParams
  boardTheme?: string
  commentRoute: string
  densityStyles: DensityStyleTypes
}

const RenderTaskGridComments: React.FC<RenderGridCommentsProps> = ({
  params,
  boardTheme,
  commentRoute,
  densityStyles,
}) => {
  return (
    <GridCommentCell
      params={params}
      densityStyles={densityStyles}
      boardTheme={boardTheme ?? 'icon.teamtasks'}
      route={commentRoute}
    />
  )
}

export default RenderTaskGridComments
